'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../utils');

var _uuidValidate = require('uuid-validate');

var _uuidValidate2 = _interopRequireDefault(_uuidValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NodeType = exports.NodeType = {
  'Root': 'Root'
};

/** main CSE class */

var Node = function () {

  /** CSE constructor */
  function Node(options) {
    _classCallCheck(this, Node);

    // Do not store token here.
    this.apiOptions = options;
  }

  /**
   * Validates a node's data for import
   * @param {Object} node The node to validate
   * @throws {Error} if the node is missing a property or property value is invalid
   */


  _createClass(Node, [{
    key: 'importNodes',


    /**
     * Imports an array of nodes into the container of this node
     * This removes any existing tree nodes by default and adds the specified new nodes.
     * To update the existing tree instead you can optionally specify the `overwrite` attribute with a value of false.
     * @param {Array} nodes The nodes to import
     * @param {boolean} overwrite - false if reimport in order to update an existing tree, otherwise true.
     * @returns {Promise<{importedNodes: number}|Error>} Resolves with response payload including number of imported
     * nodes or error object if an error occurred (either input nodes are invalid or an error in calling the Locations
     * service).
     */
    value: function importNodes(nodes, overwrite) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!nodes || !Array.isArray(nodes) || nodes.length === 0) {
          reject(new Error('Nodes to be imported are not specified.'));
        }

        if (overwrite === undefined) {
          reject(new Error('overwrite param is missing.'));
        }

        var rootNodes = [];
        for (var i = 0; i < nodes.length; ++i) {
          Node.validateNodeForImport(nodes[i]);
          if (nodes[i].type === NodeType.Root) {
            rootNodes.push(nodes[i]);
          }
        }

        if (rootNodes.length === 0) {
          reject(new Error('A root node must be specified.'));
        } else if (rootNodes.length > 1) {
          reject(new Error('Only one root node is allowed.'));
        }

        var path = ['projects', _this.apiOptions.projectId, 'trees', 'default', 'nodes:import'];

        _utils.NetUtil.apigee(_this.apiOptions).post(path.join('/'), { data: nodes, overwrite: overwrite }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'getTreeNodes',
    value: function getTreeNodes() {
      var _this2 = this;

      var nodeIdsFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this2.apiOptions.projectId, 'trees', 'default', 'nodes'];

        var nodeIdsQueryParams = {};
        if (Array.isArray(nodeIdsFilter) && nodeIdsFilter.length > 0) {
          nodeIdsQueryParams['filter[id]'] = nodeIdsFilter.join(',');
        }

        _utils.NetUtil.apigee(_this2.apiOptions).get(path.join('/'), nodeIdsQueryParams).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'getTreeNodesPage',
    value: function getTreeNodesPage() {
      var _this3 = this;

      var pageLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var pageOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this3.apiOptions.projectId, 'trees', 'default', 'nodes'];

        var queryParams = {};
        if (_utils.CommUtil.isInt(pageLimit) && pageLimit > 0) {
          queryParams['limit'] = pageLimit;
        }
        if (_utils.CommUtil.isInt(pageOffset) && pageOffset >= 0) {
          queryParams['offset'] = pageOffset;
        }

        _utils.NetUtil.apigee(_this3.apiOptions).get(path.join('/'), queryParams).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'exportTreeNodes',
    value: function exportTreeNodes() {
      var _this4 = this;

      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xlsx';

      return new Promise(function (resolve, reject) {
        if (format !== 'xlsx') {
          reject(new Error('The specified format is not supported.'));
        }

        var path = ['projects', _this4.apiOptions.projectId, 'trees', 'default', 'nodes:export'];

        _utils.NetUtil.apigee(_this4.apiOptions).post(path.join('/'), { format: format }, null, { responseType: 'blob' }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'updateNode',
    value: function updateNode(nodeId, nodeData) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this5.apiOptions.projectId, 'trees', 'default', 'nodes', nodeId];

        _utils.NetUtil.apigee(_this5.apiOptions).patch(path.join('/'), nodeData).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'moveNode',
    value: function moveNode(sourceNodeId, targetNodeId, insertOption) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (!sourceNodeId) {
          reject(new Error('Source node ID must be specified'));
        }
        if (!targetNodeId) {
          reject(new Error('Target node ID must be specified'));
        }
        if (insertOption !== 'Before' && insertOption !== 'After') {
          reject(new Error('Insert option must be one of ["Before", "After"]'));
        }

        var path = ['projects', _this6.apiOptions.projectId, 'trees', 'default', 'nodes:move'];

        var payload = {
          insertOption: insertOption,
          sourceNodeId: sourceNodeId,
          targetNodeId: targetNodeId
        };

        _utils.NetUtil.apigee(_this6.apiOptions).post(path.join('/'), payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'deleteNode',
    value: function deleteNode(nodeId) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        if (!nodeId) {
          reject(new Error('Node ID must be specified'));
        }

        var path = ['projects', _this7.apiOptions.projectId, 'trees', 'default', 'nodes', nodeId];

        _utils.NetUtil.apigee(_this7.apiOptions).delete(path.join('/')).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'addNode',
    value: function addNode(nodeDetails, targetNodeId, insertOption) {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        if (!nodeDetails) {
          reject(new Error('Node details must be specified'));
        }
        if (insertOption && !targetNodeId) {
          reject(new Error('Target node ID must be specified'));
        }
        if (targetNodeId && insertOption !== 'Before' && insertOption !== 'After') {
          reject(new Error('Insert option must be one of ["Before", "After"]'));
        }

        var path = ['projects', _this8.apiOptions.projectId, 'trees', 'default', 'nodes'];

        var params = null;
        if (insertOption) {
          params = {
            insertOption: insertOption,
            targetNodeId: targetNodeId
          };
        }

        _utils.NetUtil.apigee(_this8.apiOptions).post(path.join('/'), nodeDetails, params).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'getNodeDocuments',
    value: function getNodeDocuments(nodeId) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this9.apiOptions.projectId, 'trees', 'default', 'nodes', nodeId, 'documents'];

        _utils.NetUtil.apigee(_this9.apiOptions).get(path.join('/')).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'batchUpdateNodeDocuments',
    value: function batchUpdateNodeDocuments(nodeId, documents, includeSubLocations) {
      var _this10 = this;

      return new Promise(function (resolve, reject) {
        if (!nodeId) {
          reject(new Error('Location node ID must be specified'));
        }
        if (!documents || !documents.length) {
          reject(new Error('Documents array must be specified (and not empty)'));
        }
        if (typeof includeSubLocations !== 'boolean') {
          reject(new Error('Include sub locations must be specified as a boolean value'));
        }

        var path = ['projects', _this10.apiOptions.projectId, 'trees', 'default', 'nodes', nodeId, 'documents:batch-update'];

        var params = {
          linkDocumentsToChildren: includeSubLocations
        };

        _utils.NetUtil.apigee(_this10.apiOptions).post(path.join('/'), documents, params).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'batchDeleteNodeDocuments',
    value: function batchDeleteNodeDocuments(nodeId, documents, includeSubLocations) {
      var _this11 = this;

      return new Promise(function (resolve, reject) {
        if (!nodeId) {
          reject(new Error('Location node ID must be specified'));
        }
        if (!documents || !documents.length) {
          reject(new Error('Documents array msut be specified (and not empty)'));
        }
        if (typeof includeSubLocations !== 'boolean') {
          reject(new Error('Include sub locations must be specified as a boolean value'));
        }

        var path = ['projects', _this11.apiOptions.projectId, 'trees', 'default', 'nodes', nodeId, 'documents:batch-delete'];

        var params = {
          unlinkDocumentsFromChildren: includeSubLocations
        };

        _utils.NetUtil.apigee(_this11.apiOptions).post(path.join('/'), documents, params).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'batchGetNodes',
    value: function batchGetNodes(nodeIds, pageLimit, pageOffset) {
      var _this12 = this;

      return new Promise(function (resolve, reject) {
        if (!nodeIds || !nodeIds.length) {
          reject(new Error('Must specify an array of node ids (min length 1)'));
        }

        var path = ['projects', _this12.apiOptions.projectId, 'trees', 'default', 'nodes:batch-get'];

        var queryParams = {};
        if (_utils.CommUtil.isInt(pageLimit) && pageLimit > 0) {
          queryParams['limit'] = pageLimit;
        }
        if (_utils.CommUtil.isInt(pageOffset) && pageOffset >= 0) {
          queryParams['offset'] = pageOffset;
        }

        _utils.NetUtil.apigee(_this12.apiOptions).post(path.join('/'), nodeIds, queryParams).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'searchNodes',
    value: function searchNodes(documents, pageLimit, pageOffset) {
      var _this13 = this;

      return new Promise(function (resolve, reject) {
        if (!documents || !documents.length) {
          reject(new Error('Must specify an array of documents ({id, type}, min length 1)'));
        }

        documents.forEach(function (document) {
          if (!document.id) {
            reject(new Error('Must specify id for each document in the documents array'));
          }

          if (!document.type) {
            reject(new Error('Must specify type for each document in the documents array'));
          }
        });

        var path = ['projects', _this13.apiOptions.projectId, 'trees', 'default', 'nodes:search'];

        var queryParams = {};
        if (_utils.CommUtil.isInt(pageLimit) && pageLimit > 0) {
          queryParams['limit'] = pageLimit;
        }
        if (_utils.CommUtil.isInt(pageOffset) && pageOffset >= 0) {
          queryParams['offset'] = pageOffset;
        }

        _utils.NetUtil.apigee(_this13.apiOptions).post(path.join('/'), { documents: documents }, queryParams).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'nodesDiff',
    value: function nodesDiff(after, pageLimit, pageOffset) {
      var _this14 = this;

      return new Promise(function (resolve, reject) {
        if (!after) {
          reject(new Error('Must specify after date'));
        }

        var path = ['projects', _this14.apiOptions.projectId, 'trees', 'default', 'nodes:diff'];

        var queryParams = {
          after: after
        };

        if (_utils.CommUtil.isInt(pageLimit) && pageLimit > 0) {
          queryParams['limit'] = pageLimit;
        }
        if (_utils.CommUtil.isInt(pageOffset) && pageOffset >= 0) {
          queryParams['offset'] = pageOffset;
        }

        _utils.NetUtil.apigee(_this14.apiOptions).get(path.join('/'), queryParams).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }], [{
    key: 'validateNodeForImport',
    value: function validateNodeForImport(node) {
      if (!node.id || !(0, _uuidValidate2.default)(node.id)) {
        throw new Error('Invalid ID: ' + node.id);
      }

      if (!node.name) {
        throw new Error('No name specified');
      }

      if (!node.type) {
        throw new Error('No node type specified');
      }

      if (!node.parentId && node.type !== NodeType.Root) {
        throw new Error('Parent ID must be specified for a non-root node.');
      }

      if (node.parentId && node.type === NodeType.Root) {
        throw new Error('Root node must not have parentId specified.');
      }

      if (node.type !== NodeType.Root && !(0, _uuidValidate2.default)(node.parentId)) {
        throw new Error('Invalid parent ID: ' + node.parentId);
      }
    }
  }, {
    key: 'fromJson',
    value: function fromJson(options) {
      var nodeJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      var node = _extends(new Node(options), { id: nodeJson.id }, nodeJson.attributes);
      return node;
    }
  }]);

  return Node;
}();

exports.default = Node;